import { render, staticRenderFns } from "./PcPcmRegn.vue?vue&type=template&id=dede6a40&"
import script from "./PcPcmRegn.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports